import { InjectionToken } from '@angular/core';
import { PharmacyEscriptDescriptor } from './pharmacy-escript.descriptor';

/** Multi-provider token: each vendor descriptor registers itself here. */
export const PHARMACY_ESCRIPT_DESCRIPTORS = new InjectionToken<PharmacyEscriptDescriptor[]>('PHARMACY_ESCRIPT_DESCRIPTORS');
